<template>
  <CRow>
    <CCol col="12">
      <transition name="slide">
        <CCard>
          <CCardHeader>
            <strong>Danh sách tài khoản</strong>
          </CCardHeader>
          <CCardBody class="pt-0">
            <CDataTable
              hover
              :items="items"
              :fields="fields"
              clickable-rows
              :active-page="activePage"
              @row-clicked="rowClicked"
            >
              <template #status="data">
                <td>
                  <CBadge :color="getBadge(data.item.status)">
                    {{data.item.status}}
                  </CBadge>
                </td>
              </template>
              <template #no-items-view>
                <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                  Danh sách trống!
                </div>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { CCardHeader } from '@coreui/vue';

export default {
  data () {
    return {
      items: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'username', label: 'User', _classes: 'font-weight-bold' },
        { key: 'email', label: 'Email' },
        { key: 'role', label: 'Role' },
        { key: 'status', label: 'Status' },
      ],
      activePage: 1
    }
  },
  created() {
      this.getAll()
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
  methods: {
    getAll() {
      this.$request('/api/user/list').
        then(res => {
            this.items = res.data.userlist
            // console.log('user list: ', this.items)
        })
    },
    getBadge (status) {
      switch (status) {
        case 'Active': return 'success'
        case 'Inactive': return 'secondary'
        case 'Pending': return 'warning'
        case 'Banned': return 'danger'
        default: 'primary'
      }
    },
    rowClicked (item, index) {
      // console.log('request detail: ', item.id)
      this.$router.push({
        path: '/user/register',
        query: {
          id: item.id
        }
      });
    },
  }
}
</script>
